export default "__VITE_ASSET__B0tUaz1Z__"